// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".icon-c[data-v-216a71b0]{color:#4abca5}.splitter-color[data-v-216a71b0]{background-color:rgba(131,125,137,.2)}.bottom-bar[data-v-216a71b0]{background-color:#4abca5;border-top-style:solid;border-top-color:#837d89;border-top-width:5px;text-align:center;padding-top:10px;font-size:x-small}", ""]);
// Exports
module.exports = exports;
